import { observer } from 'mobx-react-lite';
import { draftSavedTime } from './DraftSaveTime.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import { ComposeViewState } from 'owa-mail-compose-store';

import { formatRelativeDate } from 'owa-observable-datetime';

const styles = require('./ComposeBottom.scss');
const classNames = require('classnames/bind').bind(styles);

export interface DraftSaveTimeProps {
    viewState: ComposeViewState;
}

export interface DraftSaveTimeHandle {
    getWidth(): number;
}

/**
 * Use this component to only draw Draft save time, so that when the time is changed, we don't need to rerender other components
 */
export default observer(
    function DraftSaveTime(props: DraftSaveTimeProps, ref: React.Ref<DraftSaveTimeHandle>) {
        const containerRef = React.useRef<React.RefObject<HTMLDivElement>>(React.createRef());

        React.useImperativeHandle(
            ref,
            () => ({
                getWidth() {
                    return containerRef.current.current
                        ? containerRef.current.current.clientWidth
                        : 0;
                },
            }),
            []
        );

        // Use a placeholder here to occupy the space when there isn't an available time string
        // so that we don't need to always do remeasure when draft save time is changed
        const draftSaveTime = props.viewState.lastSaveTimeStamp || new Date().toISOString();
        const className = classNames(styles.draftSaveTime, {
            isHidden: props.viewState.lastSaveTimeStamp == null,
        });
        const draftSaveTimeString = formatRelativeDate(draftSaveTime);
        return (
            <div ref={containerRef.current} className={className}>
                {draftSaveTimeString && format(loc(draftSavedTime), draftSaveTimeString)}
            </div>
        );
    },
    { forwardRef: true }
);
